import C from 'classnames';
import * as React from 'react';
import { TestingProps } from '../../Types/Testing';

interface IModalTitleProps extends TestingProps {
  children?: React.ReactNode;
  className?: string;
}

export const ModalTitle: React.FunctionComponent<IModalTitleProps> = (
  props
) => {
  return (
    <h4
      className={C('modal-title', props.className)}
      data-testid={props.testId}
    >
      {props.children}
    </h4>
  );
};
